(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const entering = new WeakSet();
  const animations = new Set();
  const play = (element, frames, options) => {
    if (preference.matches || typeof element?.animate !== 'function') return;
    const animation = element.animate(frames, options);
    animations.add(animation);
    animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const siblings = entry.target.parentElement?.children || [];
      const index = [...siblings].indexOf(entry.target);
      play(entry.target, [{ opacity: 0, translate: '0 22px' }, { opacity: 1, translate: '0 0' }], {
        duration: 700, delay: Math.min(Math.max(index, 0) % 4 * 70, 210), easing: 'cubic-bezier(.22,1,.36,1)'
      });
    });
  }, { threshold: .06 }) : null;
  const initialize = (scope = document) => {
    if (!observer || preference.matches) return;
    scope.querySelectorAll('.product-card-wrapper,.mbm-collection-head__panel,.mbm-product-context__bar,.main-page-title,.contact,.cart__blocks,.mbm-discover__panel,.mbm-result,.mbm-studio-hero__main,.mbm-studio-hero__side').forEach(element => {
      if (entering.has(element)) return;
      entering.add(element);
      observer.observe(element);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('pointerdown', event => {
    const button = event.target.closest('.mbm-button');
    if (button) play(button, [{ scale: '1' }, { scale: '.97' }, { scale: '1' }], { duration: 220, easing: 'ease-out' });
  });
  document.addEventListener('click', event => {
    const step = event.target.closest('[data-mbm-step]');
    if (!step) return;
    const preview = step.closest('[data-mbm-personalize]')?.querySelector('[data-mbm-preview]');
    if (preview) play(preview, [{ opacity: .45, translate: '0 10px' }, { opacity: 1, translate: '0 0' }], { duration: 420, easing: 'cubic-bezier(.22,1,.36,1)' });
  });
  preference.addEventListener?.('change', () => {
    if (preference.matches) { animations.forEach(animation => animation.cancel()); animations.clear(); observer?.disconnect(); }
    else { document.querySelectorAll('.product-card-wrapper,.mbm-collection-head__panel').forEach(element => entering.delete(element)); initialize(); }
  });
})();
